import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const DataProLayout = lazy(() =>
  import('../components/data-pro/DataProLayout').then((m) => ({ default: m.DataProLayout }))
)
const DataProHubPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.HubPage }))
)
const DataProCockpitPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.CockpitPage }))
)
const DataProScorePage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.ScorePage }))
)
const DataProMaturitePage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.MaturitePage }))
)
const DataProGovernancePage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataGovernancePage }))
)
const DataProGovernanceDomainDetailPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.GovernanceDomainDetailPage }))
)
const DataProQualityPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataQualityPage }))
)
const DataProQualityRuleDetailPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.QualityRuleDetailPage }))
)
const DataProMDMPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.MDMPage }))
)
const DataProMetadataPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.MetadataPage }))
)
const DataProArchitecturePage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.ArchitecturePage }))
)
const DataProModelingPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.ModelingPage }))
)
const DataProIntegrationPipelinesPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.IntegrationPipelinesPage }))
)
const DataProStoragePage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.StoragePage }))
)
const DataProSecurityPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataProSecurityPage }))
)
const DataProDwhBiPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DwhBiPage }))
)
const DataProDocumentsPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DocumentsPage }))
)
const DataProLifecyclePage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataProLifecyclePage }))
)
const DataProFrameworksPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataProFrameworksPage }))
)
const DataProDcamPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DcamPage }))
)
const DataProCdmcPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.CdmcPage }))
)
const DataProMaturityModelsPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.MaturityModelsPage }))
)
const DataProReportExecPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataProReportExecPage }))
)
const DataProIntegrationPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataProIntegrationPage }))
)
const DataProAuditTrailPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataProAuditTrailPage }))
)
const DataProSettingsPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataProSettingsPage }))
)
const DataProOutilsPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataProOutilsPage }))
)
const DataProSensitivityScannerPage = lazy(() =>
  import('../pages/data-pro/SensitivityScannerPage').then((m) => ({ default: m.SensitivityScannerPage }))
)
const DataProCatalogPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataCatalogPage }))
)
const DataProClassificationPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataClassificationPage }))
)
const DataProLineagePage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DataLineagePage }))
)
// DSPM #19 — Data Security Posture Management (PII discovery + lineage + HITL)
const DataProDspmPage = lazy(() =>
  import('../pages/data-pro').then((m) => ({ default: m.DspmPage }))
)

export const dataProRoutes: RouteObject[] = [
  {
    path: '/data-pro',
    element: <DataProLayout />,
    children: [
      { index: true, element: <DataProHubPage /> },

      { path: 'hub', element: <DataProHubPage /> },
      { path: 'cockpit', element: <DataProCockpitPage /> },
      { path: 'score', element: <DataProScorePage /> },
      { path: 'maturite', element: <DataProMaturitePage /> },
      { path: 'governance', element: <DataProGovernancePage /> },
      { path: 'governance/raci', element: <DataProGovernancePage /> },
      { path: 'governance/:id', element: <DataProGovernanceDomainDetailPage /> },
      { path: 'quality', element: <DataProQualityPage /> },
      { path: 'quality/run', element: <DataProQualityPage /> },
      { path: 'quality/:id', element: <DataProQualityRuleDetailPage /> },
      { path: 'mdm', element: <DataProMDMPage /> },
      { path: 'metadata', element: <DataProMetadataPage /> },
      { path: 'architecture', element: <DataProArchitecturePage /> },
      { path: 'modeling', element: <DataProModelingPage /> },
      { path: 'integration', element: <DataProIntegrationPipelinesPage /> },
      { path: 'storage', element: <DataProStoragePage /> },
      { path: 'security', element: <DataProSecurityPage /> },
      { path: 'dwh-bi', element: <DataProDwhBiPage /> },
      { path: 'documents', element: <DataProDocumentsPage /> },
      { path: 'lifecycle', element: <DataProLifecyclePage /> },
      { path: 'frameworks', element: <DataProFrameworksPage /> },
      { path: 'dcam', element: <DataProDcamPage /> },
      { path: 'cdmc', element: <DataProCdmcPage /> },
      { path: 'maturity-models', element: <DataProMaturityModelsPage /> },
      { path: 'report-exec', element: <DataProReportExecPage /> },
      { path: 'integrations', element: <DataProIntegrationPage /> },
      { path: 'audit-trail', element: <DataProAuditTrailPage /> },
      { path: 'settings', element: <DataProSettingsPage /> },
      { path: 'outils', element: <DataProOutilsPage /> },
      { path: 'sensitivity-scanner', element: <DataProSensitivityScannerPage /> },
      { path: 'catalog', element: <DataProCatalogPage /> },
      { path: 'catalogue', element: <DataProCatalogPage /> },
      { path: 'classification', element: <DataProClassificationPage /> },
      { path: 'lineage', element: <DataProLineagePage /> },
      { path: 'dspm', element: <DataProDspmPage /> },
    ],
  },
]
